/*
 * Mobile menu overlay (blocco `menu`).
 * Il trigger "Explore" nell'header fa da apri/chiudi (data-action="toggle-mobile-menu"): all'apertura
 * misura l'altezza della sola TOP-BAR dell'header (logo/Contact/Explore/toggle, escluso il titolo
 * capitolo che va a capo su mobile) e la passa all'overlay (--off-menu-overlay-top), così il menu parte
 * subito sotto la top-bar e copre il titolo del capitolo, che resta sotto invisibile. La top-bar resta
 * visibile in cima, senza duplicare la barra nel menu.
 * Chiude anche su Esc e cliccando un link della lista. Eventi delegati su document → robusto a DOM
 * dinamico (theme editor, view transitions).
 */
(function () {
  'use strict';

  if (typeof document === 'undefined') return;

  var html = document.documentElement;

  function overlay() {
    return document.querySelector('[data-mobile-menu]');
  }

  function pageHeader() {
    return document.querySelector('header.off-header') || document.querySelector('header');
  }

  function trigger() {
    return document.querySelector('[data-action="toggle-mobile-menu"]');
  }

  // Bottom (viewport-relative) della sola prima riga dell'header: il titolo capitolo va a capo su
  // mobile (.off-mobile-full) e va escluso così l'overlay lo copre invece di partirci sotto. Escluso
  // anche l'overlay stesso (è figlio dell'header: da aperto è fixed e coprirebbe tutto il viewport).
  function topBarBottom(h) {
    var kids = h.children;
    var max = 0;
    for (var i = 0; i < kids.length; i++) {
      var c = kids[i];
      if (c.matches('[data-chapter-title], [data-mobile-menu]')) continue;
      var b = c.getBoundingClientRect();
      if (b.height === 0) continue;
      if (b.bottom > max) max = b.bottom;
    }
    return max || Math.round(h.getBoundingClientRect().height);
  }

  function open() {
    var el = overlay();
    if (!el) return;
    var h = pageHeader();
    if (h) html.style.setProperty('--off-menu-overlay-top', Math.round(topBarBottom(h)) + 'px');
    el.hidden = false;
    html.classList.add('off-menu-open');
    var t = trigger();
    if (t) {
      t.setAttribute('aria-expanded', 'true');
      var lc = t.getAttribute('data-label-close');
      if (lc) t.textContent = lc;
    }
  }

  function close() {
    var el = overlay();
    if (!el) return;
    el.hidden = true;
    html.classList.remove('off-menu-open');
    html.style.removeProperty('--off-menu-overlay-top');
    var t = trigger();
    if (t) {
      t.setAttribute('aria-expanded', 'false');
      var lo = t.getAttribute('data-label-open');
      if (lo) t.textContent = lo;
    }
  }

  // Binding non visual-critical: eventi delegati su document, differiti a idle (convenzione MadeInEvolve).
  function bind() {
    document.addEventListener('click', function (e) {
      var toggler = e.target.closest('[data-action="toggle-mobile-menu"]');
      if (toggler) {
        e.preventDefault();
        if (html.classList.contains('off-menu-open')) close();
        else open();
        return;
      }
      // retro-compatibilità: un eventuale pulsante close esplicito
      var closer = e.target.closest('[data-action="close-mobile-menu"]');
      if (closer) {
        e.preventDefault();
        close();
        return;
      }
      // Click su un link della lista → naviga e chiude (la nuova pagina parte pulita).
      if (e.target.closest('.off-menu-overlay__item')) {
        close();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && html.classList.contains('off-menu-open')) close();
    });
  }

  var idle = typeof requestIdleCallback === 'function' ? requestIdleCallback : setTimeout;
  idle(bind);
})();
